/* eslint-disable no-param-reassign */
import React, { useRef, useContext, useEffect, useState } from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useParams } from '@thd-olt-component-react/router';
import { useStore } from '@thd-nucleus/experience-context';
import { ProductQandA } from './ProductQandA';

export const ProductQandAContainer = () => {
  const store = useStore();
  const { storeId } = store || {};
  const { isCustomerIdentified = false } = useThdCustomer();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const { itemId, page } = useParams();
  const pageNumber = page === undefined ? '1' : page;
  const seoPageNumber = parseInt(pageNumber, 10);
  let startIndex = (pageNumber - 1) * 8 + 1;

  const shouldUseSEOResults = useRef({});
  // This will only run if JS is disabled
  if (seoPageNumber !== null && shouldUseSEOResults?.current) {
    if (seoPageNumber === 1) {
      startIndex = 1;
    } else {
      startIndex = 8 * (seoPageNumber - 1) + 1;
    }
  }

  const queryOptions = ({ options, queryName }) => {
    if (queryName === 'questionsAnswers') {
      return {
        ...options,
        variables: {
          ...options.variables,
          searchTerm: '',
          pagesize: 8,
          startindex: startIndex
        },
      };
    }

    if (queryName === 'product') {
      delete options.variables.storeId;
      delete options.variables.configId;
      if (!options.variables.item) {
        options.variables.itemId = itemId;
      }
      return {
        ...options,
        variables: {
          ...options.variables,
          skipPaintDetails: true,
        },
      };
    }

    return options;
  };

  const questionsDefaultVariables = {
    storeId,
    sortBy: 'newest',
    searchTerm: null,
    startIndex,
    filters: {
      isVerifiedPurchase: false,
      prosCons: null,
      starRatings: null
    },
    isBrandPricingPolicyCompliant: isMounted ? isCustomerIdentified : false,
  };

  return (
    <QueryProvider
      cacheKey="product-questions"
      defaultVariables={questionsDefaultVariables}
      queryOptions={queryOptions}
    >
      <ProductQandA />
    </QueryProvider>
  );
};